import React from "react";
import like from "../../assets/cards/icon_thumbs_up.svg";
import LikeIdeaComponent from "../Card/LikeIdeaComponent";
import DefaultProfileImg from '../../components/assets/icon_user_profile.svg';
import iconDelete from "../../assets/delete.svg";
import editImage from '../../assets/pencil.svg';
import Tooltip from '@material-ui/core/Tooltip';

const IdeaCardHeader = ({ openEdit, openDelete, openPicture, idcapsule, currentUserId, idea, user, index, canaddlike }) => {

    let {
        image_url_profile,
        firstname,
        lastname,
        position
    } = user

    let {
        description_idea,
        time,
        tags_idea,
        attachments,
        id,
    } = idea


    let currentAttachements = attachments || []
    var createdAt = new Intl.DateTimeFormat('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).format(time)

    if (!tags_idea) {
        tags_idea = []
    }

    return (
        <div className="pt-3 pl-3 pr-3 idea-card-header">
            <div className="index-card text-center">
                <div>
                    <span>{index}</span>
                </div>
            </div>
            <div className="d-flex mt-3">
                {image_url_profile ? <img alt="profile" className="idea-profile" src={user && image_url_profile} /> :
                    <img alt="profile" className="idea-profile" src={DefaultProfileImg} />}
                <div className="ml-3">
                    <span className="idea-profile-name">
                        {user && firstname} {user && lastname}
                    </span>
                    <h2 className="idea-profile-position">{position}</h2>
                </div>
            </div>
            <p className="idea-description mb-3">{description_idea}</p>
            <h3 className="idea-date">{createdAt}</h3>
            <div className="d-flex">
                <div className="d-flex idea-wrap">
                    {tags_idea.map((tag, index) => (
                        <div key={index}>
                            <div className="idea-tag">
                                <span className="idea-tag-text">#{tag}</span>
                            </div>
                        </div>
                    ))}
                </div>
                {
                    canaddlike ?
                        <LikeIdeaComponent
                            idcapsule={idcapsule}
                            ideaId={id}
                        /> :
                        <>
                            <div className="d-flex ml-5 test-like">
                                <span className="idea-number-like">0</span>
                                <img alt="like" className="pad-like" src={like} />
                            </div>
                        </>

                }
            </div>
            <div className="d-flex justify-content-end">
                <Tooltip title="Editer" aria-label="editer" hidden={idea.creator !== currentUserId} className="pr-2">
                    <img src={editImage} alt="edit" className="edit-icon cursor-pointer" onClick={openEdit}></img>
                </Tooltip>
                <img hidden={idea.creator !== currentUserId} className="icon-delete" src={iconDelete} onClick={openDelete} alt="deleteIdea" />
            </div>
            <div>{currentAttachements.map((attachment, index) => <img key="index" onClick={() => openPicture(attachment.url)} className="picture-image-card mr-2 cursor-pointer" src={attachment.url} alt="ideaPicture" />)}</div>
            <hr />
        </div>
    )
}

export { IdeaCardHeader }